import Heading from './Heading.component';

export default Heading;
